export const types = {
    COPY: 'COPY',
    DELETE: 'DELETE',
    CREATE: 'CREATE',
    MOVE: 'MOVE',
    RENAME: 'RENAME',
    VIEW: 'VIEW',
    PUBLISH: 'PUBLISH'
};
